import { trim } from 'lodash';
import { object, string } from 'yup';

import { messages } from '../../../../data/utils/form.utils';

export const schema = object()
  .shape({
    text: string().transform(trim).required(messages.required.id).default(''),
  })
  .required()
  .noUnknown();
